import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useContext,
} from "react";
import { CustomIcons } from "../../../Components/helpers/Helpers";
import {
  Autocomplete,
  Button,
  TextField,
  Grid,
  Divider,
  Slide,
  Alert,
} from "@mui/material/";

// ICONS OPEN
import {
  Delete,
  ArrowForwardIos,
  InsertDriveFile,
  Cancel,
} from "@mui/icons-material";

import UploaderDialog from "./DocsComponents/UploaderDialog";
import ArchivosMostrar from "./DocsComponents/ArchivosMostrar";
import {
  DocsContext,
  PermissionContext,
} from "../../../Components/Context/Context";
import { CustomButtonPlusIcon } from "../../../Components/Common/Design/CustomButtonPlusIcon";
// ICONS CLOSED

import dayjs from "dayjs";
import api from "../../../api/axios";

const DocsContent = ({
  sectionId = false,
  caseId,
  nextTask,
  userLogged,
  dataCase,
  activeTask,
}) => {
  const { can } = useContext(PermissionContext);
  const canUploadDocs = can("cases", "docs");
  const canDelete = can("cases", "delete");
  const canDeleteDocs = can("cases", "deletedocs");
  const canEdit = can("cases", "edit");

  const Swal = require("sweetalert2");
  // Estados principales del componente
  const { docsChangedFlag, setDocsChangedFlag } = useContext(DocsContext);
  const [selectedFolderTypeOption, setSelectedFolderTypeOption] =
    useState(null); // Carpeta seleccionada
  const [selectedDocs, setSelectedDocs] = useState({});

  const [message, setMessage] = useState(
    activeTask?.message != "" ? activeTask?.message : "",
  );

  // Opciones para tipo de carpeta
  const folder = [
    { name: "Seleccionar", value: 0 },
    { name: "Documental Demanda", value: 1 },
    { name: "INFORMES MEDICOS", value: 2 },
    { name: "Sin Carpeta", value: 3 },
    { name: "Otro Nombre", value: 4 },
  ];
  // // Normaliza rutas para evitar barras duplicadas o invertidas
  // const normalizePath = (path) => {
  //   return path.replace(/\\/g, "/").replace(/\/+/g, "/");

  // Elimina múltiples documentos seleccionados por checkbox
  const deleteMultipleDocuments = () => {
    const allDocs = Object.values(selectedDocs).flat();

    if (allDocs?.length > 0) {
      console.log(allDocs);
      console.log(selectedDocs);

      Swal.fire({
        title: "¡Cuidado!",
        icon: "warning",
        text: `Está a punto de eliminar los archivos seleccionados`,
        showDenyButton: true,
        confirmButtonColor: "#1ab394",
        cancelButtonColor: "#d33",
        reverseButtons: true,
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
      }).then(async (response) => {
        if (response.isConfirmed) {
          // Loader mientras se procesa la eliminación
          Swal.fire({
            title: "Eliminando archivos...",
            html: '<div class="swal-loader"></div>',
            allowOutsideClick: false,
            showConfirmButton: false,
            willOpen: () => {
              Swal.showLoading();
            },
          });

          const formData = new FormData();
          formData.append("documents", JSON.stringify(allDocs));

          try {
            const { data } = await api.post(
              `${process.env.REACT_APP_API_URL}/s3/destroymultiple`,
              formData,
            );

            Swal.close(); // Cierra el loader

            if (data.success) {
              Swal.fire({
                title: "¡Archivos eliminados!",
                icon: "success",
                html: `Se han eliminado los archivos con éxito`,
                confirmButtonColor: "#1ab394",
                confirmButtonText: "Continuar",
              });

              // Fuerza recarga de documentos
              setDocsChangedFlag(!docsChangedFlag);
              setSelectedFolderTypeOption(null);
              setSelectedDocs({});
            } else if (data?.error?.errorInfo?.length > 0) {
              Swal.fire({
                title: "¡Ha ocurrido un error al eliminar los archivos!",
                icon: "error",
                confirmButtonColor: "#1ab394",
                confirmButtonText: "Continuar",
              });
            }

            console.log(data);
          } catch (error) {
            Swal.close();
            Swal.fire({
              title: "¡Error de conexión!",
              icon: "error",
              text: "No se pudo eliminar los archivos.",
              confirmButtonColor: "#1ab394",
              confirmButtonText: "Continuar",
            });
            console.error(error);
          }
        }
      });
    } else {
      Swal.fire({
        title: "¡Error!",
        icon: "error",
        text: `No se ha seleccionado ningún archivo`,
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Continuar",
      });
    }
  };

  // Confirma y pasa a la siguiente fase del flujo
  const handleCompletedDocu = () => {
    console.log("Se ha aceptado proceder al siguiente paso.");

    // Configuración de la siguiente fase (archivos requeridos)
    const config = {
      files: [
        "DNI/NIF/Pasaporte (ambas caras)",
        "Cuenta Bancaria con IBAN",
        "Autorización INSS",
        "Nº CARTILLA SEGURIDAD SOCIAL, RESOLUCIÓN DE SEGURIDAD SOCIAL SOBRE PENSIÓN DE JUBILACIÓN, INFORMES MÉDICOS ACTUALIZADOS",
      ],
    };

    const newMessage = `<div class="feed-element"><div><span class="label label-info pull-right">${dayjs().format(
      "DD/MM/YYYY HH:mm",
    )}</span><hr>Documentación Completada</div></div>`;

    let fullMessage = "";

    if (activeTask?.message) {
      console.log("ENTRO");
      fullMessage = newMessage + message;
    }

    Swal.fire({
      title: "¿Actualizar el caso?",
      icon: "warning",
      showDenyButton: true,
      confirmButtonColor: "#1ab394",
      confirmButtonText: "Sí",
      denyButtonText: "Volver",
    }).then((result) => {
      if (result.isConfirmed) {
        nextTask(
          config,
          1,
          "next",
          fullMessage != "" ? fullMessage : newMessage,
        ); // Llama a la función para avanzar en el proceso
      }
    });
  };

  const handleCancelProcess = () => {
    console.log("ha oprimido cancelar");

    // Configuración de la siguiente fase (archivos requeridos)
    var config = {};

    try {
      Swal.fire({
        title: "¿Desea cancelar el proceso?",
        icon: "warning",
        showDenyButton: true,
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Sí",
        denyButtonText: "Volver",
      }).then((result) => {
        if (result.isConfirmed) {
          console.log("Rechaza");
          nextTask(
            activeTask?.config ? activeTask?.config : config,
            2,
            true,
            "",
          );
        }
      });
    } catch (err) {
      console.error("Error en handleCancelProcess:", err);
      // Fallback: mostrar alerta simple
      Swal.fire({
        title: "Error interno",
        text: "Ocurrió un error al procesar la acción. Reintenta o contacta soporte.",
        icon: "error",
        confirmButtonColor: "#d33",
      });
    }
  };

  const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  return (
    <Grid container item xs={12} sx={{ minHeight: "400px", fontSize: "14px" }}>
      {activeTask?.message && (
        <Grid item xs={12}>
          <div dangerouslySetInnerHTML={{ __html: activeTask?.message }} />
        </Grid>
      )}
      <Grid
        item
        xs={12}
        sx={{
          border: "1px dashed #f4f9ff",
          p: "10px",
          backgroundColor: "#f4f9ff",
          height: "90px",
        }}>
        <b>Archivos descargables</b>
        <hr />
        <Button
          color="warning"
          size="small"
          variant="contained"
          component="a"
          href={`${process.env.REACT_APP_BACKEND_HOST}/storage/caseconfig/inss_authorization.pdf`}
          target="_blank"
          startIcon={
            <CustomIcons
              icon={InsertDriveFile}
              width={"18px"}
              height={"18px"}
            />
          }>
          <span className="reOrderTextButton">Autorización INSS NUEVA</span>
        </Button>
      </Grid>

      <Grid container item xs={12} sx={{ mt: 3, alignItems: "flex-start" }}>
        {canUploadDocs && (
          <Grid item xs={4} container>
            <Grid item xs={12} container sx={{ backgroundColor: "#f4f9ff" }}>
              <Grid item xs={12} p={"10px"}>
                <b>Subir documentación</b>
              </Grid>
              <Grid item xs={12} p={"10px"}>
                <Grid item xs={12} p={"10px"}>
                  <Autocomplete
                    size="small"
                    value={selectedFolderTypeOption}
                    onChange={(e, val) => {
                      setSelectedFolderTypeOption(
                        val?.name != "Seleccionar" ? val : null,
                      );
                    }}
                    options={folder}
                    getOptionLabel={(option) => option.name || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Seleccionar metodo de subida"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>

                {/*  Aquí decides renderizar el modal */}
                {selectedFolderTypeOption && (
                  <UploaderDialog
                    userLogged={userLogged}
                    caseId={caseId}
                    effects={Transition}
                    setSelectedFolderTypeOption={setSelectedFolderTypeOption}
                    selectedFolderTypeOption={selectedFolderTypeOption}
                    setDocsChangedFlag={setDocsChangedFlag}
                    docsChangedFlag={docsChangedFlag}
                    dataCase={dataCase}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        )}
        <Grid
          container
          item
          xs={canUploadDocs ? 8 : 12}
          sx={{ paddingLeft: "10px" }}>
          <ArchivosMostrar
            caseId={caseId}
            userLogged={userLogged}
            setDocsChangedFlag={setDocsChangedFlag}
            docsChangedFlag={docsChangedFlag}
            selectedDocs={selectedDocs}
            setSelectedDocs={setSelectedDocs}
            dataCase={dataCase}
          />
        </Grid>

        <Grid item xs={4}>
          {sectionId == dataCase?.task?.task_id && canEdit && (
            <CustomButtonPlusIcon
              icon={Cancel}
              text={"CANCELAR PROCESO"}
              handleFunction={handleCancelProcess}
              position={"start"}
              variant={"outlined"}
              color={"error"}
              fullWidth={true}
            />
          )}
        </Grid>

        <Grid
          container
          sx={{
            mt: 3,
            display: "flex",
            justifyContent: "space-between",
          }}>
          <Grid item xs={4}>
            {canDeleteDocs && (
              <CustomButtonPlusIcon
                icon={Delete}
                text={"BORRAR SELECCIONADOS"}
                handleFunction={deleteMultipleDocuments}
                position={"start"}
                variant={"contained"}
                color={"error"}
                fullWidth={true}
              />
            )}
          </Grid>

          <Grid item xs={4}>
            {sectionId == dataCase?.task?.task_id && canEdit && (
              <CustomButtonPlusIcon
                icon={ArrowForwardIos}
                text={"Documentación completa"}
                handleFunction={handleCompletedDocu}
                position={"end"}
                variant={"contained"}
                color={"success"}
                fullWidth={true}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DocsContent;
